<template>
    <div class="product">
        <div class="flex-con is-grow md-pad-lr is-start">
            <div class="images-col">
                <router-link :to="linkTo">
                    <div
                        v-if="image"
                        class="primary-image"
                    >
                        <img v-if="image.url" :src="$srcOverwrite(image.url)" class="image">
                        <i v-else class="fa fa-image"></i>
                    </div>
                    <div
                        v-else
                        class="primary-image m-t-sm"
                    >
                        <span class="icon">
                            <i class="fa fa-image fa-2x"></i>
                        </span>
                    </div>
                </router-link>
            </div>
            <div class="base-col">
                <div class="heading">
                    <router-link v-if="!displayOnly" :to="linkTo" class="heading">{{product.title}}</router-link>
                    <span v-else>{{product.title}}</span>
                </div>
                <div class="meta">
                    <b>SKU:</b> {{variant.sku}}
                </div>
                <div v-if="variant.options.length > 1" class="meta m-t-sm">
                    <b class="m-r-sm">Option:</b>
                    <span
                        v-for="opt in variant.options"
                        :key="opt.id"
                        class="tag is-grey m-r-sm"
                    >
                        {{opt.name}} : {{opt.value}}
                    </span>
                </div>
            </div>
            <div class="is-narrow is-start m-l-xl">
                <div class="flex-con xs-pad-lr">
                    <div>
                        <label class="soft-label">Qty:</label>
                    </div>
                    <div v-if="displayOnly" class="has-text-right">
                        {{cartItem.quantity}}
                    </div>
                </div>
                <div
                    v-if="!displayOnly"
                    class="quantity is-block"
                    :class="{ 'is-danger' : (cartItem.quantity > variant.quantity) && !allowBackorders }"
                >
                    <input
                        class="input"
                        :disabled="variant.quantity === 0 && !allowBackorders"
                        @blur="cartItem.quantity = cartItem.quantity < 1 ? 1 :(allowBackorders ?  cartItem.quantity : (variant.quantity < cartItem.quantity ? variant.quantity : cartItem.quantity))"
                        v-model.number="cartItem.quantity"
                        type="number"
                        :min="0"
                        :max="variant.quantity"
                    >
                </div>
            </div>
            <div class="is-narrow is-start has-text-right price-con">
                <div v-if="cartItem.quantity > 1" class="each soft-label">
                    <money :value="variant.price"></money>
                    <span> each</span>
                </div>
                <div v-if="cartItem.quantity" class="total">
                    <money :value="total"></money>
                </div>
            </div>
        </div>
        <div v-if="!displayOnly" class="has-text-right remove-con">
            <a @click="$emit('remove')">Remove</a>
        </div>
    </div>
</template>

<script>
import AddToCartButton from "../../../components/products/AddToCartButton";
export default {
    name : "CartProduct",
    components : {
        AddToCartButton,
    },
    props : {
        product : {
            type : Object,
            required : true,
        },
        variant : {
            type : Object,
            required : true,
        },
        displayOnly : {
            type : Boolean,
            required : false,
            default : false,
        },
    },
    computed : {
        allowBackorders () {
            return this.$getSessionContext().allowBackorders;
        },
        cartItem : {
            get () {
                return this.$store.state[this.$STORE_CONSTANTS.CART].items.find(i => i.variantId === this.variant.id);
            },
            set (item) {
                this.$store.commit(this.$STORE_CONSTANTS.CART.UPDATE_ITEM, item);
            },
        },
        linkTo () {
            return {
                name : this.$ROUTES.PRODUCTS_VIEW,
                params : {
                    id : this.product.id,
                }
            };
        },
        image () {
            return this.variant.images[0] ? this.variant.images[0] : this.product.images[0];
        },
        total () {
            return this.variant.price * this.cartItem.quantity;
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/_theme';

    .images-col {
        text-align: center;

        .primary-image {
            .no-image {
                height: 120px;
                padding-top: 25px;

                .fa {
                    color: $grey-lighter;
                    font-size: 80px;
                }
            }

            img {
                max-width: 120px;
                max-height: 120px;
            }
        }
    }

    .end-col {
        flex:0 0 120px;
    }
    .meta {
        font-size:13px;
    }
    .heading {
        margin-bottom:8px;
        line-height:20px;
        font-size:17px;
    }

    .soft-label {
        display:block;
        color:$grey;
        font-size:14px;
        &.is-smaller {
            font-size:12px;
        }
    }

    .select.quantity {
        margin-top:4px;
        select {
            border-top:none;
            border-left:none;
            border-right:none;
            border-bottom:2px solid $warning;
            border-radius:0;
        }
    }


    .price-con {
        .each {
            margin-bottom:10px;
        }
        .total {
            font-weight:bold;
            font-size:18px;
        }
    }
    .button {
        height:26px;
        width:220px;
        text-transform:uppercase;
        font-size:13px;
        font-weight:bold;
    }

    .remove-con {
        a {
            padding-bottom:1px;
            border-bottom:1px solid $link;
        }
    }

</style>
